export default "__VITE_ASSET__FyZcGPE5__"